import { CREDIT_CARD_NUMBER_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const validateCreditCardNumber = (creditCardNumber: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };

  const isValid = CREDIT_CARD_NUMBER_VALIDATOR.test(String(creditCardNumber));
  if (!isValid) {
    result.error = 'Invalid Credit Card Number';
    result.isValid = false;
  }

  return result;
};
